/**
 * LoggedOutBar (VH-293)
 *
 * The report page keeps working on its token when the login ends, but the
 * buttons that change the plan need a login. Before this bar they simply
 * vanished; now the page says why and offers the login back to this session.
 * Sticky: the page scrolls to the open exercise, which would hide a bar that
 * only sat at the top.
 */
import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export default function LoggedOutBar({ onLogin }) {
  const { t } = useTranslation()
  return (
    <div
      role="alert"
      className="sticky top-2 z-30 mb-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-md"
      data-testid="capture-logged-out"
    >
      <div className="flex items-start gap-2">
        <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
        <p className="flex-1">{t('captureSession.loggedOut.body')}</p>
      </div>
      <button
        type="button"
        onClick={onLogin}
        className="mt-3 w-full min-h-[44px] rounded-lg bg-amber-600 px-4 py-2 font-semibold text-on-neutral hover:bg-amber-700"
        data-testid="capture-logged-out-login"
      >
        {t('captureSession.loggedOut.login')}
      </button>
    </div>
  )
}
